import { useEffect, useState } from "react";
import { ColorResult } from "react-color";
import styled from "styled-components";
import colors from "../../../theme/colors";
import ColorPicker from "../colorPicker/ColorPicker";

interface IInputColorPicker {
  color: string;
  handleChangeColor: (e: ColorResult) => void;
}

const Container = styled.div`
  display: flex;
  border-bottom: 1px solid ${(props) => props.theme.colors.line};
  outline: none;
  padding-bottom: 8px;
  position: relative;
  width: 100%;

  > div {
    width: 20px;
    height: 20px;
    margin-right: 8px;
    border-radius: 50%;
    cursor: pointer;
  }

  span {
    cursor: pointer;
    color: ${props => props.theme.colors.label};
  }

  hr {
    border: none;
    height: 2px;
    background-color: ${(props) => props.theme.colors.error};
  }

  @media screen and (max-width: 460px) {
    width: 100% !important;
  }
`;

const InputColorPicker: React.FC<IInputColorPicker> = ({
  color,
  handleChangeColor
}) => {
  const [showPicker, setShowPicker] = useState(false);
  
  return (
    <Container onClick={() => setShowPicker(true)}>
      {showPicker && (
        <ColorPicker
          color={color}
          handleChangeColor={handleChangeColor}
          setShowPicker={setShowPicker}
        />
      )}
      <div style={{ backgroundColor: color, border: `1px solid ${colors.border}` }} />
      <span>{color}</span>
    </Container>
  );
};

export default InputColorPicker;
